import React, {Suspense} from "react";
import {BrowserRouter} from "react-router-dom";
import {SnackbarProvider} from "notistack";
import {makeStyles} from "@material-ui/core/styles";
import CustomTheme from "./layouts/common/CustomTheme";
import Navigator from './layouts/navigation/Navigator';
import './i18n';
import {AppContextProvider} from "./context/AppContext";
import Loader from "./components/core/Loader";
import CookiePolicyBanner from "./components/core/CookiePolicyBanner";
import ServiceWorkerWrapper from "./utils/ServiceWorkerWrapper";

const useStyles = makeStyles(() => ({
    root: {
        display: "flex",
        flex: 1,
        justifyContent: "center"
    }
}));


function App() {
    const classes = useStyles();

    return (
        <BrowserRouter>
            <ServiceWorkerWrapper/>
            <SnackbarProvider maxSnack={3}>
                <div className={classes.root}>
                    <AppContextProvider>
                        <CustomTheme>
                            <Suspense fallback={<Loader/>}>
                                <CookiePolicyBanner/>
                                <Navigator/>
                            </Suspense>
                        </CustomTheme>
                    </AppContextProvider>
                </div>
            </SnackbarProvider>
        </BrowserRouter>
    );
}


export default App;
